<template>
  <div id="app">
    <div class="container" v-if="!isMobile">
      <div class="row">
        <div class="col-md">
        </div>
        <div class="col-md">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">会員アプリ利用ご案内</h5>
              <p class="card-text text-left">
                <br>スマホ専用ページです。
                <br>スマホから下記QRコードをスキャンすることで、またはスマホのブラウザで下記urlを直接入力して開けます。
              </p>
              <p class="card-text"><small class="text-muted">https://www.semcent-jp.com/app/index.html?#/</small></p>
            </div>
            <img src="./assets/startqrcode.png" class="card-img img-rounded card-img-bottom" alt="店舗アプリQRコード">
          </div>
        </div>
        <div class="col-md">
        </div>
      </div>
    </div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top" v-if="isMobile">
      <i v-if="this.$store.state.showBack" v-on:click="goBack()" class="fa fa-angle-left fa-2x pull-left"></i>
      {{ this.$store.state.title }}
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <router-link class="nav-link " to="/">ホーム <span class="sr-only">(current)</span></router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link " to="/about">店舗情報</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link " to="/notice">お知らせ</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link " to="/menu">メニュー情報</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link " to="/course">コース情報</router-link>
          </li>
        </ul>
      </div>
    </nav>
    <div class="main-content" v-if="isMobile">
      <router-view />
    </div>
    <footer class="fixed-bottom" v-if="isMobile">
      <ul class="nav nav-fill">
        <li class="nav-item">
          <router-link class="nav-link navtab" to="/"><i class="fa fa-home fa-2x"></i><br>ホーム</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link navtab" to="/calendar"><i class="fa fa-calendar  fa-2x"></i><br>カレンダ</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link navtab" to="/coupon"><i class="fa fa-gift fa-2x"></i><br>クーポン</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link navtab" to="/stamp"><i class="fa fa-support fa-2x"></i><br>スタンプ</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link navtab" to="/my"><i class="fa fa-id-card-o fa-2x"></i><br>会員</router-link>
        </li>
      </ul>
    </footer>
    <Toast></Toast>
    <Waiting></Waiting>
    <ModalConfirm v-bind:def="this.$store.state.confirmdef"></ModalConfirm>
  </div>
</template>
<script>
import Toast from './components/Toast.vue'
import Waiting from './components/ModalWaiting.vue'
import ModalConfirm from './components/ModalConfirm.vue'
import sx from './utils/core.js'

export default {
  components: {
    Toast,
    ModalConfirm,
    Waiting
  },
  data() {
    return {
      items: [],
      isMobile: true
    }
  },
  created() {
    this.isMobile = this.checkMobile()
    // authenticated status
    this.$store.state.authenticated = JSON.parse(localStorage.getItem('authenticated') || false)
    this.$store.state.automanaged = JSON.parse(localStorage.getItem('automanaged') || false)
    this.$store.state.userinfo = JSON.parse(localStorage.getItem('userinfo') || '{}')
  },
  mounted() {
    this.isMobile = this.checkMobile()
    // authenticated status
    this.$store.state.authenticated = JSON.parse(localStorage.getItem('authenticated') || false)
    this.$store.state.automanaged = JSON.parse(localStorage.getItem('automanaged') || false)
    this.$store.state.userinfo = JSON.parse(localStorage.getItem('userinfo') || '{}')
    this.$store.state.baseurl = localStorage.getItem('baseurl') || 'https://cloud.salesmini.cn'
    if (!localStorage.getItem('token')) {
      var params = {
        username: 'guest',
        corpid: 40,
        bucketid: '17',
        token: ''
      }
      sx.request(
        this.$store.state.baseurl + '/app/account/login',
        params,
        function (result) {
          if (result.status === 'ok') {
            localStorage.setItem('token', result.data.token)
          } else {
            console.log('The username and / or password is incorrect')
          }
        }
      )
    }
  },
  methods: {
    goBack() {
      this.$router.replace({ name: this.$store.state.pageBack })
      this.$store.state.showBack = false
      this.$store.state.pageBack = ''
    },
    checkMobile() {
      var flag = (/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i).test(navigator.userAgent);
      return flag;
    }
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 11pt;
}

#nav {
  padding: 20px;
}

#nav a {
  font-weight: bold;
  color: #fb6e14;
}

#nav a.router-link-exact-active {
  color: #fb6e14;
}

.navtab {
  padding: 0.5rem 0.5rem !important;
}

a.nav-link:hover {
  color: #fb6e14;
}

.main-content {
  padding-top: 60px;
  padding-bottom: 60px;
  /*padding-bottom要等于或大于footer的height值*/
  background-color: #fff;
}

footer {
  width: 100%;
  height: 60px;
  text-align: center;
  font-size: 10pt;
  margin-top: -60px;
  background-color: #f2f2f2;
}

footer a {
  color: #6c757d;
}

footer a.router-link-exact-active {
  color: #fb6e14;
}
</style>
